import { Star } from "lucide-react";
import { fileUrl } from "@/lib/api";
import HelpfulButton from "@/components/HelpfulButton";

export function Stars({ rating = 5, size = "h-3.5 w-3.5" }) {
  return (
    <span className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          className={`${size} ${i <= Math.round(rating) ? "text-amber-400" : "text-slate-200"}`}
          fill="currentColor"
        />
      ))}
    </span>
  );
}

export function ReviewsSection({ reviews = [], rating = { average: 0, count: 0 } }) {
  if (!reviews.length) return null;
  return (
    <div className="grid grid-cols-[minmax(0,1fr)] gap-6 lg:grid-cols-[300px_minmax(0,1fr)]" data-testid="reviews-section">
      <div className="rounded-2xl border border-line bg-brand-soft p-7">
        <p className="label-eyebrow">Satisfaction client</p>
        <p className="mt-3 font-display text-5xl font-black text-ink" data-testid="global-rating">
          {rating.average || 4.9}
          <span className="text-2xl text-slate-400">/5</span>
        </p>
        <Stars rating={rating.average || 5} size="h-5 w-5" />
        <p className="mt-3 text-sm text-slate-600">
          Basé sur {rating.count || reviews.length} avis vérifiés de clients ISMO-TECH.
        </p>
      </div>

      <div className="grid grid-cols-[minmax(0,1fr)] gap-4 sm:grid-cols-2 xl:grid-cols-3">
        {reviews.slice(0, 6).map((review, i) => (
          <figure
            key={review.id}
            style={{ animationDelay: `${i * 60}ms` }}
            data-testid={`review-card-${i}`}
            className="flex animate-fade-up flex-col rounded-2xl border border-line bg-white p-5 transition-shadow duration-300 hover:shadow-[0_16px_40px_rgba(0,0,0,0.07)]"
          >
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-brand text-sm font-bold text-white">
                {review.author_name?.[0] || "C"}
              </span>
              <span>
                <span className="block text-sm font-bold text-ink">{review.author_name}</span>
                <Stars rating={review.rating} />
              </span>
            </div>
            <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-slate-600">“{review.comment}”</blockquote>
            {review.photo_url && (
              <img
                src={fileUrl(review.photo_url)}
                alt="Photo du client"
                loading="lazy"
                className="mt-3 h-16 w-16 rounded-lg border border-line object-cover"
              />
            )}
            {review.admin_reply && (
              <div className="mt-3 rounded-lg bg-brand-soft p-2.5" data-testid={`review-reply-${i}`}>
                <p className="text-[10px] font-bold uppercase tracking-wide text-brand">Réponse ISMO-TECH</p>
                <p className="mt-0.5 line-clamp-2 text-xs text-slate-600">{review.admin_reply}</p>
              </div>
            )}
            <div className="mt-4 flex items-center justify-between gap-2 border-t border-line pt-3">
              <span className="min-w-0 truncate text-[11px] font-semibold uppercase tracking-wide text-slate-400">
                {review.product_name}
              </span>
              <HelpfulButton review={review} />
            </div>
          </figure>
        ))}
      </div>
    </div>
  );
}

export default ReviewsSection;
